"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePin = void 0;
const ValidationResponse_1 = require("./ValidationResponse");
/**
 *
 * Checks if user entered a valid PIN
 * @param {string} pToValidate - The PIN to be validated.
 * @returns {ValidationResponse}
 */
const validatePin = (pToValidate) => {
    const p = Array.from(pToValidate);
    if (p.some((val) => isNaN(parseInt(val))) || // Check for invalid characters
        p.every((val) => val === p[0]) || // Check for same number
        p.every((val, i) => val === (parseInt(p[0]) + i).toString()) || // Check for sequential numbers
        p.every((val, i) => val === (parseInt(p[0]) - i).toString()) // Check for reverse sequential
    ) {
        return ValidationResponse_1.ValidationResponse.INVALID_PIN;
    }
    else {
        return ValidationResponse_1.ValidationResponse.VALID;
    }
};
exports.validatePin = validatePin;
